export const semanticTokens = {
  colors: {
    'chakra-body-bg': {
      _light:
        'radial-gradient(88.02% 32.04% at 50% 7.61%, #FFFFFF 0%, #E9E9EC 100%)',
      _dark:
        'radial-gradient(78.02% 20% at 50% 0%, hsl(287, 20%, 10%) 0%, hsl(197, 6%, 5%) 100%)',
    },
    'chakra-body-text': 'neutral.700',
    'card-bg-layer-1': {
      _dark: 'neutral.50',
      _light: 'white',
    },
    'card-bg-layer-2': {
      _dark: 'neutral.100',
      _light: 'white',
    },
    'card-bg-layer-3': {
      _dark: 'neutral.200',
      _light: 'white',
    },
    'card-bg-layer-4': {
      _dark: 'neutral.300',
      _light: 'white',
    },
    'card-bg-layer-5': {
      _dark: 'neutral.400',
      _light: 'white',
    },
    'chakra-placeholder-color': {
      _light: 'blackAlpha.300',
      _dark: 'whiteAlpha.300',
    },
  },
}
